var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ListComment" } },
    [
      _vm._l(_vm.comments, function (comment) {
        return _c("div", { key: comment._id, staticClass: "comment-item" }, [
          _c(
            "div",
            { staticClass: "comment-header" },
            [
              _vm.usersMap[comment.user]
                ? _c("Avatar", {
                    attrs: {
                      size: 35,
                      src: _vm.usersMap[comment.user].gravatar,
                      username: _vm.usersMap[comment.user].name,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "comment-username" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.usersMap[comment.user]
                        ? _vm.usersMap[comment.user].name
                        : "Unknown User"
                    ) +
                    "\n                "
                ),
                comment.edited
                  ? _c("span", { staticClass: "edited-label" }, [
                      _vm._v(_vm._s(_vm.$t("task.edited"))),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "comment-date" }, [
                _vm._v(_vm._s(_vm.formatDate(comment.createdAt))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "comment-body" }, [
            _vm.editingCommentId === comment._id
              ? _c("div", [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editedCommentMessage,
                        expression: "editedCommentMessage",
                      },
                    ],
                    domProps: { value: _vm.editedCommentMessage },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.editedCommentMessage = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.cancelEdit } }, [
                    _vm._v(_vm._s(_vm.$t("calendar.cancel"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.saveComment(comment._id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("calendar.save")))]
                  ),
                ])
              : _c("div", [
                  _vm._v(
                    "\n                " +
                      _vm._s(comment.message) +
                      "\n            "
                  ),
                ]),
            _vm._v(" "),
            _vm.editingCommentId !== comment._id
              ? _c("div", { staticClass: "comment-actions" }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.editComment(comment)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chatbotv2.editBlock")))]
                  ),
                  _vm._v("\n                -\n                "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.confirmDeleteComment(comment._id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chatbotv2.delete")))]
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.showDeleteConfirm
        ? _c(
            "div",
            {
              staticClass: "delete-confirm-overlay",
              on: { click: _vm.cancelDelete },
            },
            [
              _c(
                "div",
                {
                  staticClass: "delete-confirm-dialog",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "confirm-content" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "alert-icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: { cx: "12", cy: "12", r: "10" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", y1: "8", x2: "12", y2: "12" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", y1: "16", x2: "12", y2: "16" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("task.deleteComment")))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.deleteComment(_vm.deleteCommentId)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.yes")))]
                  ),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.cancelDelete } }, [
                    _vm._v(_vm._s(_vm.$t("message.no"))),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }